// Behaviour for the global flash toast layer (shared/_flash_toasts):
// close button, and auto-hide for success/notice toasts. Errors stay until
// dismissed. Runs on both DOMContentLoaded and turbo:load, so every
// toast is bound exactly once via a dataset marker.

const AUTOHIDE_MS = 6000

function dismiss (toast) {
  if (!toast || toast.classList.contains('is-leaving')) return
  toast.classList.add('is-leaving')
  setTimeout(() => { // matches the CSS transition
    const wrap = toast.closest('.flash-toasts')
    toast.remove()
    if (wrap && !wrap.querySelector('.flash-toast')) wrap.remove()
  }, 250)
}

function initFlashToasts () {
  document.querySelectorAll('.flash-toast').forEach((toast) => {
    if (toast.dataset.ftBound) return
    toast.dataset.ftBound = '1'
    const close = toast.querySelector('.flash-toast__close')
    if (close) close.addEventListener('click', () => dismiss(toast))
    if (toast.dataset.autohide === 'true') setTimeout(() => dismiss(toast), AUTOHIDE_MS)
  })
}

document.addEventListener('DOMContentLoaded', initFlashToasts)
document.addEventListener('turbo:load', initFlashToasts)
